module.exports = __webpack_public_path__ + "img/special_22.8e5881a5.png";